/**
 * Parse catalog certifications: "Name — Issuer — Year" items joined by " | ".
 */
export function parseCertifications(raw) {
  return String(raw || "")
    .split("|")
    .map((item) => item.trim())
    .filter(Boolean)
    .map((item) => {
      const parts = item.split(/\s+[—–-]\s+/).map((p) => p.trim()).filter(Boolean);
      const yearPart = parts.find((p) => /^\d{4}$/.test(p));
      const withoutYear = parts.filter((p) => p !== yearPart);
      return {
        key: item,
        name: withoutYear[0] || item,
        issuer: withoutYear.slice(1).join(" — ") || "",
        year: yearPart || "",
      };
    });
}
